/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (node: BaseFeature): CodeBlock[] => {
    let blocks: CodeBlock[] = [];
    const project = node.project;

    const vars = node.getSettingValue('VARS').concat(node.getSettingValue('AUTOVARS'));
    const TIMER_NAME = 'var_poll_timer';
    const INTERVAL = Number(node.getSettingValue('INTERVAL'));
    const intervalValue = Number(INTERVAL) * 1000;

    // using main loop for now
    //     blocks.push({
    //         location: 'VARIABLE_DECLARATIONS',
    //         blockType: BlockType.CODE,
    //         template: `
    // struct k_timer var_poll_timer_var;`,
    //     });

    // blocks.push({
    //     location: 'boot',
    //     blockType: BlockType.CODE,
    //     template: `
    // k_timer_init(&var_poll_timer_var, var_poll_timer, NULL);
    // k_timer_start(&var_poll_timer_var, K_MSEC(${(intervalValue).toString()}), K_MSEC(${(intervalValue).toString()}));`,
    // });

    //     blocks.push({
    //         location: 'FUNCTION_DECLARATIONS',
    //         blockType: BlockType.CODE,
    //         template: `
    // extern void var_poll_timer(struct k_timer *timer_id);`,
    //     });


    //     blocks.push({
    //         location: 'FUNCTION_DEFINITIONS',
    //         blockType: BlockType.CODE,
    //         template: `
    //     void var_poll_timer(struct k_timer *timer_id) {
    //         /****var_poll_timer_elapsed****/
    //     }`,
    //     });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
void var_poll_timer() {
    /****var_poll_timer_elapsed****/
}

void timer_variable_handler(struct k_timer *timer_id) {
    var_poll_timer();   
}
`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
struct k_timer timer_variables;`,
    });


    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
k_timer_init(&timer_variables, timer_variable_handler, NULL);
k_timer_start(&timer_variables, K_MSEC(1000), K_MSEC(1000));
`,
    });

    //     blocks.push({
    //         location: 'MAIN',
    //         blockType: BlockType.CODE,
    //         template: `
    // var_poll_timer();`,
    //     });


    for (let i = 0; i < vars.length; i += 1) {
        blocks = blocks.concat(vars[i].getCodeBlocks());
    }

    return blocks;
};
